import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { ShopCompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { initShop } from 'reducks/shop/operations'
import { initStore } from 'reducks/store/operations'
import { initConfirm } from 'reducks/confirm/operations'

const ShopEditComplete: FC = () => {
  const dispatch = useDispatch()

  const backToAdminTop = useCallback(() => {
    dispatch(push('/admin/shops'))
    dispatch(initConfirm())
    dispatch(initShop())
    dispatch(initStore())
  }, [dispatch])

  return (
    <Layout title={'完了｜新規店舗の登録'}>
      <ShopCompleteTemplate
        iconPath={'/icon/done/shop.svg'}
        firstLabel={'新規店舗の登録が'}
        secondLabel={'完了しました'}
        backToTop={backToAdminTop}
      />
    </Layout>
  )
}

export default ShopEditComplete
